import { PORTAL_RECEIVED_GET_ROLE_DEFINITIONS } from "../../legacy/actions/portal-actions";
import { legacyFulfill } from "../utils";
import { BuilderType, portalCacheTags } from "./portalApiHelpers";
export type RoleDefinition = {};

export const roleDefinitionsApi = (builder: BuilderType) => ({
  getRoleDefinitions: builder.query<RoleDefinition[], void>({
    query: () => `service/role-definitions.json`,
    providesTags: [portalCacheTags.ROLE_DEFINITIONS],
    onQueryStarted: legacyFulfill(PORTAL_RECEIVED_GET_ROLE_DEFINITIONS),
  }),
});
